export default "__VITE_ASSET__5ca5939a__"